import React, { Component } from "react";

import TYCheckBox from "../../../TYCheckBox";


export default class ExportFormColumns extends Component {
    static defaultProps = {
        columns: {},
        onListChange: _ => {},
        defaultSelected: []
    }

    constructor(props){
        super(props);
        this.state = { 
            keys: props.defaultSelected 
        };
    }

    toggleColumn = k => {
        let keys = this.state.keys;
        let index = keys.indexOf(k);

        if(index === -1)
            keys.push(k);
        else
            keys.splice(index, 1);

        this.setState({keys: keys}, () => {
            this.props.onListChange(this.state.keys);
        });
    };

    render(){
        const {
            columns
        } = this.props;

        return <div>
            <div className="bold">Colonnes *</div>
            <br />
            {
                Object.keys(columns).map(k => {
                    return <div className="export-header-checkbox-container" key={k}>
                        <TYCheckBox
                            checked={this.state.keys.indexOf(k) !== -1}
                            onToggle={() => { this.toggleColumn(k) }}
                        /> 
                        { columns[k] }
                    </div>;
                })
            }
        </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/Operations/Export/Forms/Columns.js